import { render, staticRenderFns } from "./ColorGroupsDialog.vue?vue&type=template&id=7d497a5e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ColorGroupsDialog.vue?vue&type=script&lang=ts&"
export * from "./ColorGroupsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ColorGroupsDialog.vue?vue&type=style&index=0&id=7d497a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d497a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
